import classNames from 'classnames';
import React from 'react';
import styles from './Pills.module.scss';

interface Props {
  style?: React.CSSProperties;
  pillStyle?: React.CSSProperties;
  items: string[];
}

interface PillProps {
  text: string;
  isLast?: boolean;
  style?: React.CSSProperties;
  isSmall?: boolean;
}

export const Pill: React.FC<PillProps> = ({ text, isLast, style, isSmall }) => {
  return (
    <div className={classNames(styles.pill, { [styles.last]: isLast, [styles.small]: isSmall })} style={style}>
      <span className={styles.pillText}>{text}</span>
    </div>
  );
};

export const Pills: React.FC<Props> = ({ style, pillStyle, items }) => {
  return (
    <div className={styles.pillContainer} style={style}>
      {items.map((p, i) => (
        <Pill key={i} text={p} isLast={i === items.length - 1} style={pillStyle}></Pill>
      ))}
    </div>
  );
};

export default Pills;
